import { useContext } from "react";
import { convertFinalCheckLabel } from "../../utils";
import { ReportContext } from "../context";
import { useGetReportSummaryQuery } from "../services/shared.api";
const useFinalCheckLabel = () => {
    var _a;
    const { reportId, diffId, selectedCheck } = useContext(ReportContext);
    const { data: summary } = useGetReportSummaryQuery({
        diff_report_id: diffId,
        ui_id: reportId,
    });
    return convertFinalCheckLabel((_a = summary === null || summary === void 0 ? void 0 : summary.checks_report.report.scans[selectedCheck]) === null || _a === void 0 ? void 0 : _a.checks);
};
export default useFinalCheckLabel;
//# sourceMappingURL=useFinalCheckLabel.js.map